import Link from "@components/common/Link/Link";
import clsx from "clsx";
import { FC, useEffect, useRef } from "react";
import s from "./Accordion.module.scss";



export type AccordionItem = {
    title: string;
    children: React.ReactNode;
    type?: 'default' | 'overlay' | 'link';
    href?: string;
    external?: boolean;
}


export type AccordionProps = {
    items: AccordionItem[]
    paddedContent?: boolean;
}
const Accordion: FC<AccordionProps> = ({ items, paddedContent }) => {
    const accordionRef = useRef<HTMLUListElement>(null)

    const toggleAccordion = (e: React.MouseEvent<HTMLButtonElement>) => {
        const target = e.currentTarget;
        const parent = target.closest(`.${s["accordion-item"]}`) as HTMLLIElement;

        //close all accordions 
        const allAccordions = accordionRef.current.querySelectorAll(`.${s["accordion-item"]}`);
        allAccordions.forEach((item: HTMLElement) => {
            if (item === parent) return
            item.classList.remove(s["active"]);
        })

        if (parent.classList.contains(s["active"])) {
            parent.classList.remove(s["active"]);
        } else {
            parent.classList.add(s["active"]);
        }

    }
    const calculateContentHeights = () => {
        if (!accordionRef) return
        const contentItems = accordionRef.current.querySelectorAll(`.${s["transition-wrapper"]}`);
        contentItems.forEach((item: HTMLElement, index) => {
            const itemHeight = getComputedStyle(item.querySelector(`.${s["accordion-content"]}`)).height
            item.style.setProperty("--content-height", itemHeight);
        })
    }

    useEffect(() => {
        calculateContentHeights()
    }, [accordionRef.current])

    return (
        <ul className={s["accordion"]} ref={accordionRef}>
            {items && items.map((item, i) => (
                <li key={i} className={s["accordion-item"]}>
                    <h3>
                        {item.type === 'link' ?
                            <Link type="button" link={{ url: item?.href, target: item.external ? "EXTERNAL" : '' }} className={s["accordion-button"]} >
                                <span className={s["accordion-title"]}>
                                    {item.title}
                                </span>
                                <span className={s["accordion-icon"]}></span>
                                <span className={s["accordion-chevron"]}>

                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="17" cy="17" r="17" fill="black" />
                                        <path d="M14 12H22V20" stroke="white" strokeWidth="1px" />
                                        <line x1="21.8536" y1="12.3536" x2="11.8536" y2="22.3536" stroke="white" strokeWidth="1px" />
                                    </svg>
                                </span>
                            </Link>


                            : <button type="button" className={s["accordion-button"]} onClick={toggleAccordion}>
                                <span className={s["accordion-title"]}>
                                    {item.title}
                                </span>
                                <span className={s["accordion-icon"]}></span>
                                <span className={s["accordion-chevron"]}>

                                    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="17" cy="17" r="17" fill="black" />
                                        <rect x="24" y="16.6111" width="1" height="14" transform="rotate(90 24 16.6111)" fill="white" />
                                        <rect x="16.6113" y="10" width="1" height="14" fill="white" className={s["animated-line"]} />
                                    </svg>

                                </span>
                            </button>}

                    </h3>
                    <div className={s["transition-wrapper"]}>
                        <div className={clsx(s["accordion-content"], { [s["padded-content"]]: paddedContent })}>
                            {item.children}
                        </div>
                    </div>


                </li>
            ))}
        </ul>
    )
}

export default Accordion